import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { buildRoutes } from '../../routes/contentRoutes';

const PAGE_404 = lazy(() => import('../../pages/presentation/auth/Page404'));
const ContentRoutes = () => {
	const routes = buildRoutes();
	return (
		<Routes>
			{routes.map((page) => (
				<Route key={page.path} {...page} />
			))}
			<Route path='*' element={<PAGE_404 />} />
		</Routes>
	);
};

export default ContentRoutes;
